import { render, staticRenderFns } from "./SportList.vue?vue&type=template&id=0d9e9e4f&"
import script from "./SportList.vue?vue&type=script&lang=js&"
export * from "./SportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports